import React from "react";

function pickColor(score, mode) {
    if (mode === "authenticity") {
        // Higher = better
        if (score >= 70) return "#16A34A";
        if (score >= 30) return "#F59E0B";
        return "#DC2626";
    }
    // Default: risk mode → higher = worse
    if (score <= 30) return "#16A34A";
    if (score <= 70) return "#F59E0B";
    return "#DC2626";
}

export function ScoreGauge({ score = 0, label = "Rischio", size = 128, mode = "risk" }) {
    const s = Math.max(0, Math.min(100, Math.round(score)));
    const color = pickColor(s, mode);
    const r = 42;
    const c = 2 * Math.PI * r;
    const offset = c - (s / 100) * c;

    return (
        <div
            data-testid="score-gauge"
            className="flex flex-col items-center gap-2"
            style={{ width: size }}
        >
            <div className="relative" style={{ width: size, height: size }}>
                <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
                    <circle cx="50" cy="50" r={r} fill="none" stroke="#E5E9F2" strokeWidth="8" />
                    <circle
                        cx="50"
                        cy="50"
                        r={r}
                        fill="none"
                        stroke={color}
                        strokeWidth="8"
                        strokeDasharray={c}
                        strokeDashoffset={offset}
                        strokeLinecap="round"
                        style={{ transition: "stroke-dashoffset 0.6s ease-out" }}
                    />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                        <div className="text-2xl font-bold text-[#172033]">{s}</div>
                        <div className="text-[10px] text-[#64748B] uppercase tracking-wider">/ 100</div>
                    </div>
                </div>
            </div>
            <div className="text-xs font-medium text-[#64748B] uppercase tracking-wider">{label}</div>
        </div>
    );
}

export default ScoreGauge;
